import filters from '@/filters/customFormatters'
import campaignsUtils from '@/mixins/campaignsUtils'
import { CHANNEL_OPTIONS, CHANNEL_LABELS, CAMPAIGN_STATUSES, CAMPAIGN_TYPES } from '@/utils/campaignOptions'
import campaignsService from '@/api/campaignsService'
import authService, { USER_ROLES } from '@/api/authService'

export default {
  name: 'CampaignCard',
  mixins: [filters, campaignsUtils],
  components: {

  },
  props: {
    campaign: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: '',
      required: false
    },
    selectable: {
      type: Boolean,
      default: false,
      required: false
    },
    isSelected: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      fullCampaign: null,
      creativitiesOpen: false,
      creativitiesLoading: false,
      selected: this.isSelected,
      authData: authService.authData
    }
  },
  computed: {
    // most computed props are in the campaign mixin
    isExteriorAgency () {
      return this.authData.user.role === USER_ROLES.AGENCY_EXTERIOR
    },
    isExterior () {
      return this.campaign.type === CAMPAIGN_TYPES.EXTERIOR
    },
    statusTag () {
      return this.type === 'compact' ? this.statusLabel.charAt(0) : this.statusLabel
    },
    link () {
      if (this.isExterior && [CAMPAIGN_STATUSES.CENTRAL_REJECTED, CAMPAIGN_STATUSES.CENTRAL_ACCEPTED, CAMPAIGN_STATUSES.CENTRAL_READY].indexOf(this.campaign.status) !== -1) {
        return `/campaigns/${this.campaign.id}?tab=4`
      }
      if (this.campaign.status === CAMPAIGN_STATUSES.CENTRAL_REJECTED) {
        return `/campaigns/${this.campaign.id}?tab=${this.isExterior ? 4 : 3}`
      }
      if (this.campaign.status === CAMPAIGN_STATUSES.AGENCY_PROVISIONING) {
        return `/campaigns/${this.campaign.id}?tab=3`
      }
      return this.isConfirmed ? `/${this.isExterior ? 'exterior-' : ''}campaign-detail/${this.campaign.id}` : `/campaigns/${this.campaign.id}`
    },
    fullCreativities () {
      if (!this.fullCampaign) {
        return this.creativities
      }
      return this.fullCampaign.channels
        .filter(c => c.creativities && c.type !== CHANNEL_OPTIONS.GOOGLE)
        .flatMap(c => {
          const label = CHANNEL_LABELS[c.type]
          const files = Array.isArray(c.creativities) ? c.creativities : [c.creativities]
          return files.map(f => {
            let url = typeof f === 'object' ? f.creativity_url : f
            if (c.type === CHANNEL_OPTIONS.YOUTUBE) url = c.video_url
            return {
              url,
              name: label,
              has_link: typeof url === 'string' ? url.startsWith('http') : false
            }
          })
        })
    }
  },
  methods: {
    prevent (ev) {
      ev.preventDefault()
      ev.stopPropagation()
    },
    isMediumConfirmed (channel) {
      return (
        (
          channel.type === CHANNEL_OPTIONS.DV360 ||
          channel.type === CHANNEL_OPTIONS.LOCALINVENTORYADS ||
          channel.type === CHANNEL_OPTIONS.GOOGLESEARCHADS ||
          channel.type === CHANNEL_OPTIONS.META
        ) ||
        (
          channel.type === CHANNEL_OPTIONS.GEOLOCATION &&
          (
            channel.sonata_status === 'active' ||
            channel.sonata_status === 'finished'
          )
        )
      )
    },
    getConfirmationIcon (channel) {
      return this.isMediumConfirmed(channel)
        ? 'icon-tick-circle'
        : 'icon-clock'
    },
    closeCreativities () {
      const menu = this.$refs.dropdown
      if (menu) {
        menu.close()
      }
    },
    onCreativitiesToggle () {
      const menu = this.$refs.dropdown
      if (menu && menu.open && !this.fullCampaign) {
        this.loadFullCampaign()
      }
    },
    async loadFullCampaign () {
      this.creativitiesLoading = true
      try {
        const campaign = await campaignsService.getCampaign({ id: this.campaign.id })
        this.fullCampaign = campaign
      } catch (err) {
        // eslint-disable-next-line
        console.error('[campaign-card.js] Error fetching gcloud creativity', err)
      }
      this.creativitiesLoading = false
    },
    onCheckboxChange () {
      if (!this.disabled) {
        this.$emit('select', { campaign: this.campaign, state: this.selected })
      }
    }
  }
}
